import { render, staticRenderFns } from "./IndexSearchResultsTable.vue?vue&type=template&id=2cf0ad7c&scoped=true&"
import script from "./IndexSearchResultsTable.vue?vue&type=script&lang=js&"
export * from "./IndexSearchResultsTable.vue?vue&type=script&lang=js&"
import style0 from "./IndexSearchResultsTable.vue?vue&type=style&index=0&id=2cf0ad7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf0ad7c",
  null
  
)

export default component.exports